import React, { useEffect, useState, useRef } from 'react';
import { Container, CircularProgress, Typography, Paper, Toolbar, Button, Grid, Divider } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux';
import { IdentityActions, NoticeActions, NotificationActions } from '../../../store';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px'
    },
    infoTitle: {
        "& h3": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    table: {
        "& td": {
            paddingRight: '10px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const noticesSelector = (state) => state.Notices;
const IdentitySelector = (state) => state.Identity;

const NoticeDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const noticeActions = bindActionCreators(NoticeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(noticesSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    // 削除確認ダイアログ表示フラグ
    const [ dlgOpen, setDlgOpen ] = React.useState(false);

    /**
     * 
     * 戻るボタン押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{props.dataTitle}</Typography>
                        <Typography component="h2" variant="inherit">{props.dataDate}</Typography>
                    </div>
                </Toolbar>

                <form className={classes.form}>
                    <div id="login_duration_description" dangerouslySetInnerHTML={{ __html: props.dataContent }} />
                    <Grid container item xs={12} spacing={2} justify="center">
                        <Grid item xs={3} sm={6}>
                            <Button fullWidth variant="contained" size="medium"
                                startIcon={<ArrowBackIosIcon />}
                                onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

        </Container>
    )    
}

export default withStyles(style, { withTheme: true })(NoticeDetail);